import styled, { keyframes } from 'styled-components';

export const ChangelogButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 36px;
  padding: 0 12px;
  background: #fff;
  border: 1px solid #e1e3e8;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 91, 219, 0.06);
  cursor: pointer;
  color: #202223;
  transition: background 0.2s, box-shadow 0.2s, border-color 0.2s;
  &:hover {
    background: #f6f7f9;
    border-color: #c9ccd3;
    box-shadow: 0 4px 16px rgba(0, 91, 219, 0.12);
  }
`;

const bellRing = keyframes`
  0% { transform: rotate(0); }
  10% { transform: rotate(-15deg); }
  20% { transform: rotate(10deg); }
  30% { transform: rotate(-10deg); }
  40% { transform: rotate(6deg); }
  50% { transform: rotate(-4deg); }
  60% { transform: rotate(2deg); }
  70% { transform: rotate(-1deg); }
  80% { transform: rotate(1deg); }
  90% { transform: rotate(0); }
  100% { transform: rotate(0); }
`;

export const AnimatedBell = styled.span`
  display: flex;
  align-items: center;
  animation: ${bellRing} 1.2s infinite;
`;
